import "./ProgressBar.less"

const ProgressBar = ({ progress, style }) => {
  return (
    <div className="monitoring-program-progress-bar" style={style}>
      {Boolean(progress) && <div className="progress" style={{ width: `${progress}%` }} />}
      <div className="bar" />
    </div>
  )
}

export default ProgressBar
